<template>
  <div
    class="bg-static-default-low rounded-full caption flex w-fit items-center overflow-hidden p-4 pr-8 text-center md:body-2"
    data-chip-premium
  >
    <DynamicIcon class="shrink-0" :icon="tag.icon as IconName" />
    <div class="ml-4 whitespace-nowrap text-left">
      {{ tag.text }}
    </div>
  </div>
</template>

<script setup lang="ts">
import type { IconName } from '@backmarket/design-system/icons/icons'
import DynamicIcon from '@backmarket/nuxt-layer-cms/DynamicIcon.vue'

import type { ChipTag } from '../../ConditionGuidance.types'

defineProps<{
  tag: ChipTag
  index: number
}>()
</script>
